import ReactDOM from 'react-dom/client'

import { AppContextProvider } from './AppContext'
import { InventoryContextProvider } from '../domains/inventory/index.js'
import { mockWindowData } from '../domains/config/_mock/mockAppConfig'

import { i18n } from '../shared/i18n/i18n'
import plPL from '../shared/locales/pl_PL.json'
import enEN from '../shared/locales/en_EN.json'

import { Logger } from '../shared/utils/logger.js'

import { AppRuntime } from './AppRuntime.jsx'
import { AppShell } from './AppShell.jsx'

import '../shared/styles/index.scss'

/**
 * Application entry point.
 *
 * Responsibilities:
 * - Initializes the i18n singleton.
 * - Finds the root DOM element to mount the application.
 * - Renders the root `AppContextProvider` and the main `AppShell` and `AppRuntime` components.
 */

// Initialise i18n singleton before first render.
// Locale from WP-injected window data; fallback to pl_PL in dev or when unset.
const locale = window.bimCadaplusData?.language ?? (import.meta.env.DEV ? mockWindowData.language : 'pl_PL')
const translations = locale.startsWith('en') ? enEN : plPL
const fallback = plPL
i18n.init(locale, translations, fallback)

const projectId =
  window.bimCadaplusData?.projectId ??
  (import.meta.env.DEV ? mockWindowData.projectId : null)

const rootElement = projectId ? document.getElementById(projectId) : null

if (!rootElement) {
  Logger.error({
    message: 'Mount point not found',
    content: `#${projectId ?? '(no projectId)'}`,
  })
} else {
  ReactDOM.createRoot(rootElement).render(
    <AppContextProvider>
      <AppShell>
        <InventoryContextProvider>
          <AppRuntime />
        </InventoryContextProvider>
      </AppShell>
    </AppContextProvider>
  )
}
